import styled from 'styled-components';
import { CheckoutAssistedFinanceStyled } from '../CheckoutAssistedFinanceStyled';

export const CheckoutAssistedFinanceStyledAP = styled(CheckoutAssistedFinanceStyled)`
    
`;
